import { isFeatureEnabled } from 'owa-feature-flags';
import { getOpxHostApi } from 'owa-opx';

export function sendOpxIsDirtyMessage(isPostMessageToHostOnComposeDirtyEnabled: boolean): void {
    if (isFeatureEnabled('cmp-dirtyStateOpx') && isPostMessageToHostOnComposeDirtyEnabled) {
        const opxHostApi = getOpxHostApi();
        opxHostApi.sendScenarioData({ action: 'IsDirty', result: 'Metadata' });
    }
}
